export function useTrackOnClick({ event, wtData, options = {} }) {
  if (!event || !wtData) {
    return
  }

  const { target, currentTarget } = event
  const element = currentTarget.href ? currentTarget : target

  window['_wt'](wtData)

  if (
    !options.preventRedirect &&
    element.href &&
    !(event.ctrlKey || event.metaKey || event.shiftKey) &&
    element.target !== '_blank'
  ) {
    window.location = element.href
  }

  if (
    element.href &&
    (event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      element.target === '_blank')
  ) {
    return
  }

  event.preventDefault()
}
